import { URLS } from '../../../constants';
import apiClient from '../../client';

const GoalLibrary = {
  getGoalLibraryGrid: ({
    heading,
    roleId,
    type,
    assignedTo,
    pagination,
    order,
    name,
    filterValue,
  }: {
    heading: string;
    roleId: string;
    type: string;
    assignedTo: string;
    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: string;
  }) =>
    apiClient.post(URLS.getAllInterventionLibrary, {
      data: {
        heading,
        roleId,
        type,
        pagination,
        assignedTo,
        filter: [
          {
            filterKey: 'name',
            filterValue: filterValue || '',
          },
        ],
        sorting: {
          order: order || 'DESC',
          fieldName: name || 'createdDate',
        },
      },
    }),
  HistoryGoalLibrary: ({ id }: { id: any }) =>
    apiClient
      .post(URLS.goalLibraryHistory, {
        data: {
          id,
        },
      })
      .then(res => {
        return res; // Return the response if needed
      }),
};
export default GoalLibrary;
